import React from 'react';
import CreateProjectForm from './CreateProjectForm';
import { Button, ButtonColor, ButtonSize, IconType } from 'ui-builder';
import { useAuthorizationChecker } from 'authorization-scope';
import { TeamPermission } from 'nekst-api';
import { usePopupFormManager } from 'features/nekst-widgets';

function ActiveCreateProjectButton() {
  const popupManager = usePopupFormManager();

  const openForm = () => {
    popupManager.openForm(
      <CreateProjectForm title="Add New Property" />,
    );
  };

  return (
    <Button
      color={ButtonColor.BLUE}
      size={ButtonSize.MEDIUM}
      text="Add New Property"
      isFilled
      iconType={IconType.PLUS}
      onClick={openForm}
      dataKey="add-new-project"
    />
  );
}

function ProjectLimitReachedButton() {
  return (
    <Button
      color={ButtonColor.BLUE}
      size={ButtonSize.MEDIUM}
      text="Add New Property"
      isFilled
      iconType={IconType.PLUS}
      isDisabled
      title="You reached the properties limit. Update your plan to create a new property."
    />
  );
}

export default function CreateProjectButton() {
  const { isGranted } = useAuthorizationChecker();

  if (isGranted(TeamPermission.ACCESS_PROJECT_CREATION)) {
    if (isGranted(TeamPermission.CREATE_PROJECT)) {
      return (<ActiveCreateProjectButton />);
    } else {
      return (<ProjectLimitReachedButton />);
    }
  } else {
    return null;
  }
}
